import { NgModule } from '@angular/core';
import { CommonModule} from '@angular/common';
import { SecureURL } from './secureURL.pipe';

@NgModule({
  imports:[
    CommonModule
  ],
  declarations: [SecureURL],
  providers: [],
  exports: [SecureURL]
})
export class SecureURLPipeModule {

}
